import { render, staticRenderFns } from "./ai-anim.vue?vue&type=template&id=4f412f58&scoped=true&"
import script from "./ai-anim.vue?vue&type=script&lang=js&"
export * from "./ai-anim.vue?vue&type=script&lang=js&"
import style0 from "./ai-anim.vue?vue&type=style&index=0&id=4f412f58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f412f58",
  null
  
)

export default component.exports